import React from "react";
import QboxmailApi from "../../qboxmailApi";
import AsyncSelect from "react-select/async";
const debounce = require("debounce-promise");

import { t } from "i18next";
import cx from "classnames";
import s from "./domainSelect.scss";

export default class DomainSelect extends React.Component {
  constructor(props) {
    super(props);
    let client = new QboxmailApi({ useCookie: true });
    this.state = { client, currentQuery: undefined };
  }

  onInputChange = (val) => {
    this.setState({ currentQuery: val === "" ? undefined : val });
  };

  getDomains = (query) => {
    let params = {
      per: 50,
      query,
      customer_code: this.props.customer_code,
    };
    let method = "getDomains";
    let key = "no_email_accounts";
    if (this.props.archive) {
      method = "getArchiveDomains";
      key = "no_email_accounts_archive";
    }

    if (!query) {
      params = { query: this.props.initialValue };
    }

    if (this.props.etlive) {
      params.etlive = true;
    }

    return this.state.client[method](params).then((data) => {
      let containSelectedDomain = false;
      let d = data.resources.map((res) => {
        if (this.state.initialDomain && res.code === this.state.initialDomain.value) {
          containSelectedDomain = true;
        }
        const emailCount = this.props.countPostmaster && !this.props.archive ? res[key] + 1 : res[key];
        const isDisabled = this.props.disabledIf && this.props.disabledIf(res);
        const disabledReason = this.props.disabledReason;

        return {
          value: res.code,
          label: `${res.name} - ${this.props.withoutEmailCounter || isDisabled ? "" : "(" + emailCount + ")"} ${
            isDisabled && disabledReason ? `(${disabledReason})` : ""
          }`,
          isDisabled,
          limit_tracemail_21_days: res.limit_tracemail_21_days,
        };
      });

      if (this.state.initialDomain && !containSelectedDomain) {
        d.push(this.state.initialDomain);
      }

      if (!query && this.props.initialValue) {
        this.setState({ selected: d.filter((o) => o.value === this.props.initialValue)[0] });
      }

      return d;
    });
  };

  onChange = (option) => {
    this.setState({ selected: option });
    let value = option ? option.value : null;

    if (this.props.onChange) {
      this.props.onChange({ domain: value, limit_tracemail_21_days: option?.limit_tracemail_21_days });
    }
  };

  render() {
    const styles = {
      dropdownIndicator: () => ({ display: "none" }),
      indicatorSeparator: () => ({ display: "none" }),
    };

    const { className, selectSizeSmall, errors } = this.props;

    return (
      <div className={cx(className, s.domainSelect)}>
        <label className={s.label}>{t("input.label.domain")}</label>

        <AsyncSelect
          styles={styles}
          className={cx("wrapSelect", {
            ["selectSizeSmall"]: selectSizeSmall,
            ["selectWithError"]: !!errors,
          })}
          onInputChange={this.onInputChange}
          classNamePrefix={"select"}
          defaultOptions={!!this.props.initialValue}
          loadOptions={debounce(this.getDomains, 500, { leading: true })}
          value={this.state.selected}
          onChange={this.onChange}
          isClearable
          placeholder={t("input.placeholder.domainCustomer")}
          noOptionsMessage={() =>
            this.state.currentQuery ? t("input.placeholder.domain.notFound") : t("input.placeholder.domain.hint")
          }
          ref={(el) => (this.selectElement = el)}
        />
      </div>
    );
  }
}
